module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0010.jpg?v=6fd28b01";